import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { Trip } from "../../store/admin/tripsStore";

export interface TripListParams {
  page?: number;
  limit?: number;
  status_id?: string;
  search?: string;
  device_id?: string;
  date_from?: string;
  date_to?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface TripListBody {
  data?: Trip[];
  meta?: ListMeta;
}

export interface TripListResult {
  data: Trip[];
  meta?: ListMeta;
}

function cleanParams(params: TripListParams): Record<string, string | number> {
  const out: Record<string, string | number> = {
    page: params.page ?? 1,
    limit: params.limit ?? 8,
  };
  if (params.status_id) out.status_id = params.status_id;
  if (params.search) out.search = params.search;
  if (params.device_id) out.device_id = params.device_id;
  if (params.date_from) out.date_from = params.date_from;
  if (params.date_to) out.date_to = params.date_to;
  return out;
}

export function useTripsList(params: TripListParams = {}) {
  const companyId = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.trips.list(companyId, params),
    queryFn: ({ signal }) =>
      getJson<TripListBody>("/tripsList", cleanParams(params), { signal }).then(
        (body) => ({ data: body.data ?? [], meta: body.meta }),
      ),
  });
}
